import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import { NavLink } from "react-router-dom";
import createstore from "store";
import { CheckActionPermission } from "Actions/commonAction";
import get from "lodash/get";

export default function Menubar() {
  const pathname = window.location.pathname;
  const appendModule = pathname.includes("app");
  const data = appendModule
    ? pathname.includes("leave")
      ? [
          // { name: "Dashboard", route: "/track/leave/dashboard", index: 0 },
          { name: "Leaves", route: "/track/leave", index: 0 },
        ]
      : [
          // { name: "Dashboard", route: "/track/attendance/dashboard", index: 0 },
          { name: "Attendance", route: "/track/attendance", index: 0 },
          { name: "GPS Attendance", route: "/track/gps", index: 1 },
          { name: "Biometric", route: "/track/biometric", index: 2 },
        ]
    : pathname.includes("attendance")
    ? [{ name: "Attendance", route: "/attendance", index: 0 }]
    : [
        { name: "Leaves", route: "/leave", index: 0 },
        { name: "Holidays", route: "/holiday", index: 1 },
      ];
  let value = data.findIndex((x) => pathname.includes(x.route));
  value = value == -1 ? 0 : value;
  return (
    <div>
      <div className="common-menubar-header">
        <Tabs
          className="common-menubar-tabs"
          value={value}
          indicatorColor="primary"
          textColor="primary"
        >
          {data.map((item, subindex) => {
            const [isTrue, permissions] = CheckActionPermission("biometricDevice");
            const { AuthenticationAction } = createstore.getState();
            const masterprofileid = get(AuthenticationAction, "login.masterprofileid");

            return (item.name == "Biometric" && !isTrue ) && (item.name == "Biometric" && masterprofileid != 9) ? 
            "" 
            :
            (
              <NavLink
              key={subindex}
              to={`${appendModule ? "/app" : ""}${item.route}`}
            >
              <Tab
                key={subindex}
                label={item.name}
                className="common-menubar-tabs-content"
              />
            </NavLink>
            );
          })}
        </Tabs>
        <div className="tab-border" />
      </div>
    </div>
  );
}
